import React, { useContext, useState, useEffect } from 'react';
import HeaderForm from './headerformnurse';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Navigate,
  useNavigate,
  Link
} from "react-router-dom";

import VisibilityIcon from '@mui/icons-material/Visibility';

import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DeleteIcon from '@mui/icons-material/Delete';

import { useDispatch } from "react-redux";
import { AppContext } from '../context';

import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { toast } from "react-toastify";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}



function Applicationstatus(props) {

  const [manageapplicationstatusList, setManagApplicationsStatusList] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [reason, setReason] = React.useState(false)
  const [reasondeatils, setReasonDeatils] = React.useState('');
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [nursedata, setNursedata] = React.useState('');
  const { storage } = useContext(AppContext);
  const Axios = axios.create({
    baseURL: storage[0].backEndUrl
    // baseURL: process.env.REACT_APP_ENV_URL
  });
  let navigate = useNavigate();

  useEffect(() => {

    var user = JSON.parse(window.localStorage.getItem('nursedata'));

    if (Object.keys(user).length === 0) {
      //  navigate(`/`);
    } else {
      setNursedata(user);
      loadApplications();


    }

  }, []);

  const loadApplications = () => {
    var usernew = JSON.parse(window.localStorage.getItem('nursedata'));
    setNursedata(usernew);
    Axios.post(`/appication_status_list`, { location: usernew.location, nurse_id: usernew.empid, "pageNo": pageNo, "perPage": perPage })
      .then(res => {

        if (res.data.status == true) {
          if (res.data.message.length > 0) {
            setManagApplicationsStatusList(res.data.message);
            setTotalCount(res.data.pagination.totalCount);
            setTotalPage(res.data.pagination.totalPage);
          } else {
            setManagApplicationsStatusList([]);
          }
        }else{
          setManagApplicationsStatusList([]);
          setTotalCount(res.data.pagination.totalCount);
          setTotalPage(res.data.pagination.totalPage);
        }


        setFirstLoading(false);
      });
  }

  const handlereason = (consent_form) => {
    setReasonDeatils(consent_form);
    setReason(true);

  }
  const handleCloselogss = () => setReason(false);

  const handleDownloadFile = (id) => {
    let applItem = getApplicationRow(id);
    Axios.get(`/downloadforms/${id}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, `parent_consent_forms_${applItem.stuid}.zip`);
      })
  }

  const handlePhysicianDownloadFile = (id) => {
    let applItem = getApplicationRow(id);
    Axios.get(`/application/download-physician-form/${id}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, `physician_forms_${applItem.stuid}.zip`);
      })
  }

  const downloadBlob = (data, filename) => {
    // Create a blob from the res data
    const blob = new Blob([data], { type: data.type });

    // Create a link element
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    window.URL.revokeObjectURL(link.href);
    document.body.removeChild(link);

  }

  const getApplicationRow = (id) => {
    return manageapplicationstatusList.find(item => item.id == id);
  }

  const perPageChange = (e) => {
    setPerPage(e.target.value);
    setPageNo(1);
    var usernew = JSON.parse(window.localStorage.getItem('nursedata'));

    Axios.post(`/appication_status_list`, { location: usernew.location, nurse_id: usernew.empid, "pageNo": 1, "perPage": e.target.value })
      .then(res => {
        console.log('order_list');
        console.log(res.data);
        if (res.data.status == true) {
          if (res.data.message.length > 0) {
            setTotalCount(res.data.pagination.totalCount);
            setTotalPage(res.data.pagination.totalPage);
            console.log('order_list');
            setManagApplicationsStatusList(res.data.message);

          } else {
            setTotalCount(0);
            setTotalPage(0);
            setManagApplicationsStatusList([]);
          }
        }

        else {
          setTotalCount(0);
          setTotalPage(0);
          setManagApplicationsStatusList([]);
        }

      })
  };

  const changePage = (page) => {
    var usernew = JSON.parse(window.localStorage.getItem('nursedata'));
    if (page < 1) page = 1;
    if (page > totalPage) page = totalPage;
    setFirstLoading(true);
    setPageNo(page);


    Axios.post(`/appication_status_list`, { location: usernew.location, nurse_id: usernew.empid, "pageNo": page, "perPage": perPage })
      .then(res => {

        console.log(res.data);

        if (res.data.status == true) {
          if (res.data.message.length > 0) {
            setTotalCount(res.data.pagination.totalCount);
            setTotalPage(res.data.pagination.totalPage);
            console.log('order_list');
            setManagApplicationsStatusList(res.data.message);

          } else {
            setTotalCount(0);
            setTotalPage(0);
            setManagApplicationsStatusList([]);
          }
        }

        else {
          setTotalCount(0);
          setTotalPage(0);
          setManagApplicationsStatusList([]);
        }
        setFirstLoading(false);
      })
  }

  const truncateString = (str, num) => {
    if (str.length > num) {
      return str.slice(0, num) + '...';
    } else {
      return str;
    }
  }

  const [uploading, setUploading] = useState(false);
  const [uploadErr, setUploadErr] = useState('');
  const [uploadSuccess, setUploadSuccess] = useState('');
  const [alldelete, setAlldelete] = useState(null);
  const [physicianDeleteId, setPhysicianDeleteId] = useState(null);
  const [openLogDelele, setOpenLogDelele] = React.useState(false);
  const handleDeleleClose = () => setOpenLogDelele(false);
  const handleDeleleOpen = () => setOpenLogDelele(true);
  const handleOpenDelete = (userid, id) => {
    setPhysicianDeleteId(id);
    setAlldelete(userid);
    setOpenLogDelele(true);
  }

  const handlePhycianDelte = () => {
    if (uploading) return;
    setUploadErr('');

    setUploading(true);

    Axios.post(`/physician_file_delete/`, { id: physicianDeleteId, consent_form_id: alldelete })
      .then(res => {
        if (res.data.status) {
          setUploadSuccess('Physician Form Deleted Successfully');
          loadApplications();
          setTimeout(() => {
            setPhysicianDeleteId(null);
            setAlldelete(null);
            setOpenLogDelele(false);
            setUploadSuccess('');
          }, 2000);

        } else {
          setUploadErr('Error');
        }
        setUploading(false);
      })
  }

  const handleDownload = (fileName) => {
    const link = document.createElement('a');
    link.href = storage[0].imageEndUrl + fileName;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <>
      <HeaderForm />

      <div className='regis-main-sec forms-main-sec'>
        <div className='container-fluid'>

          <div className='row'>
            <div className='col-md-12'>
              <div className='regis-head forms-heading-sec'>
                <h2>Application Status {props.name}</h2>

                <Link to="/application">  <p className='stts-sec view-sts  go-frm-cols go-new-add'>VIEW APPLICATION LIST</p>

                  <div class="scroll-prompt" scroll-prompt="" ng-show="showPrompt" style={{ opacity: '1' }}>
                    <div class="scroll-prompt-arrow-container new-go-spp">
                      <div class="scroll-prompt-arrow"><div></div></div>
                      <div class="scroll-prompt-arrow new-scroll"><div></div></div>
                    </div>
                  </div>
                </Link>

              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <div className='club-sec application-sec'>
                <div className='container-fluid '>

                  <div className='club-inner-secss form-table-sec table-section-route table-form appl-sec'>
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='indicate-secss'>
                          <p className='style-new style-new-ntk'><span className='square-secss'><span className='new-round-redss new-app-green'><span className='new-roud-val'>A</span></span><span className='dash-sec-nwe'> - </span></span><span style={{ color: '#059652', fontWeight: '700' }}>Approved</span></p>
                          <p className='style-new-ntk'><span className='square-sec-redsss'><span className='new-round-redss'><span className='new-roud-val'>R</span></span> <span className='dash-sec-nwe'> - </span> </span><span style={{ color: '#fb0b0b', fontWeight: '700' }}>Rejected</span></p>
                        </div>

                      </div>
                      <div class="col-sm-3"  >
                        <div class="sorting-e-form " style={{ marginTop: '-50px' }}>
                          <label style={{ width: '100%' }}><span style={{ marginRight: '10px', fontSize: '14px' }}>Show entries</span>
                            <select className='selee-sort' onChange={perPageChange} value={perPage}>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </select>

                          </label>
                        </div>
                      </div>
                      <div class="col-md-6">

                        {manageapplicationstatusList.length > 0 ?
                          <p class="total-user right-user tot-app" style={{ marginTop: '-55px' }}>Total Applications {totalCount}</p>
                          : null}


                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12'>
                        <table class="table table-bordered">
                          <thead class="thead-light thead-travel thead-form">
                            <tr>

                              <th className='loc-width'>Location</th>
                              <th className='std-id-width'>Student ID</th>
                              <th className='std-name-width'>Student Name</th>
                              <th className='grade-width'>Grade</th>
                              <th className='date-width'>Parent Consent Form</th>
                              <th className='date-width'>Physician Form</th>
                              <th className='stts-width'>Status</th>
                              {/* <th className='action-width'>Action</th> */}
                            </tr>
                          </thead>
                          <tbody className='tbody-light tbody-form'>
                            {
                              firstLoading ? <tr ><td colSpan={7}><div className="spinner-border" role="status" style={{ width: "1rem", height: "1rem", marginLeft: "6px" }}></div></td></tr> : <>
                                {manageapplicationstatusList.length > 0 ?

                                  manageapplicationstatusList.map((userd, index) =>
                                    <tr key={index}>

                                      <td>{userd.school_name}</td>
                                      <td className='std-id'>{userd.stuid}</td>
                                      <td>{userd.student_name} {userd.last_name}</td>
                                      <td>{userd.stu_grade}</td>
                                      <td><p className='form-comp'>
                                        {userd.document_details.length > 0 && userd.document_details.length}

                                        <span className={` ${(userd.pending_parent_form != 0) && 'red-down'} ${(userd.pending_parent_form == 0) && 'blue-down'}`}>
                                          <a title="Download"><DownloadIcon onClick={() => handleDownloadFile(userd.id)}
                                          /></a></span></p>

                                      </td>
                                      <td><p className='form-comp'>


                                        {userd.physician_document_details.length > 0 &&
                                          <>

                                            <ul className='list-group'>
                                              {
                                                userd.physician_document_details.map((item, index2) => (
                                                  <li className='list-group-item psycn-form-link' key={index2}>
                                                    <span className={`${(userd.physician_document_details.length > 1) && 'blue-down'}`}>
                                                      <a title="Download"> <DownloadIcon className='download_icon' onClick={() => handleDownload(item.document)}
                                                      /></a></span>   {truncateString(item.document, 35)}
                                                    <DeleteIcon className='delete_icon' onClick={() => handleOpenDelete(userd, item.id)} />
                                                  </li>
                                                ))
                                              }
                                            </ul>
                                          </>

                                        }

                                      </p>
                                      </td>
                                      <td>
                                        <div className='round-stss'>
                                          <div className='sttus-sec'>
                                            <span className=
                                              {`green-down over-grn-dwn  ${(userd.consent_details.status == 'Rejected') && 'square-sec-redss'}`} style={{ fontWeight: '700', fontSize: '17px' }}>
                                              {(userd.consent_details.status == 'Rejected') && 'R'}
                                              {(userd.consent_details.status == 'Approved') && 'A'}</span>
                                          </div>
                                          <div className='stst-visi'>
                                            <span className='visib-sec'
                                              onClick={() => handlereason(userd.consent_details)}><VisibilityIcon /></span>
                                          </div>
                                        </div>
                                      </td>

                                    </tr>
                                  )

                                  : <tr><td colSpan={7}>No Data Found</td></tr>}
                              </>
                            }

                          </tbody>
                        </table>
                        {/* pagination code start  */}

                        {totalPage > 1 ? <>
                          <div class="pagination-sec" style={{ boxShadow: '#ff98001a 0px 7px 16px 0px', width: "auto", float: "right", border: "1px solid #FF9800", marginTop: "2px", marginRight: "5px", height: "40px" }}>
                            <div style={{ float: "left", padding: "0px 0px", color: "#0B5CAB", fontSize: "14px", width: '100%', position: 'relative', display: 'inline-flex' }}>
                              <div class="" style={{ backgroundColor: '#FF9800', color: '#ffffff' }}>
                                <p style={{ marginBottom: '0px', padding: '9px 10px' }}>Page {pageNo} of {totalPage}</p>
                              </div>
                              <div className="pagin-sec">
                                <i className="fa-solid fa-angle-left" style={{ float: "left", marginTop: "10px", marginLeft: "10px", cursor: "pointer", fontSize: '18px', color: '#727272' }} onClick={(e) => changePage(pageNo - 1)}></i>
                                <span className="go-sec" style={{ float: "left", fontSize: "15px", marginTop: "10px", marginLeft: "10px", marginRight: '10px', color: "#727272" }}>Go to </span>
                                <input type="number"
                                  value={pageNo} onChange={(e) => {
                                    !isNaN(parseInt(e.target.value)) && parseInt(e.target.value) > 0 ? changePage(parseInt(e.target.value)) : changePage(1)
                                  }}
                                  style={{ paddingTop: '4px', color: "rgb(0, 23, 55)", margin: "8px 6px 0px 4px", fontSize: "14px", width: "34px", height: '34px', float: "left", height: "22px", textAlign: "center", border: "1px solid #727272", borderRadius: "3px", outline: "none" }} />

                                <i className="fa-solid fa-angle-right" style={{ float: "left", marginTop: "10px", marginRight: '6px', marginLeft: "5px", cursor: "pointer", fontSize: '20px', color: '#727272' }} onClick={(e) => changePage(pageNo + 1)}></i>
                              </div>
                            </div>

                          </div>
                        </> : ''
                        }

                        {/* pagination code end */}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* modal section start */}

      <BootstrapDialog
        onClose={handleCloselogss}
        aria-labelledby="customized-dialog-title"
        open={reason} className="route-view copy-view logout-view login-modal app-modal resn-modl">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloselogss}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec' style={{ paddingTop: '0px' }}>
              {reasondeatils != null && reasondeatils != '' &&
                <>
                  {
                    reasondeatils.status == 'Approved' ?
                      <h2 className='uplod-secddd'>Approval Feedback</h2>
                      :
                      <h2 className='uplod-secddd'>Reason For Rejection</h2>
                  }
                  <p className='uplod-para approv-fed'>{reasondeatils.reason}</p>
                </>
              }

            </div>



          </Typography>
        </DialogContent>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleDeleleClose}
        aria-labelledby="customized-dialog-title"
        open={openLogDelele} className="route-view copy-view logout-view login-modal app-modal action-modl">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleDeleleClose}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {/* <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec'  style={{display:  rejectLog  ? 'none' : 'block' }}> */}
            <div className={`copy-sec-modal logout-sec-modal add-club-sec app-club-sec `}  >

              <h2>Do you want to delete this Physician Form?</h2>


              <div className='button-sec-app'>
                {alldelete != null ?
                  <>
                    <button className="btn btn-login btn-submit bt-forms btn-appr" onClick={() => handlePhycianDelte()}> {
                      uploading ?
                        <>
                          Yes <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </>
                        :
                        <>
                          Yes
                        </>
                    } </button>
                    <button className="btn btn-login btn-submit bt-forms btn-reject" onClick={handleDeleleClose}>No </button>

                  </>

                  :
                  ''}

              </div>
              {
                uploadSuccess ?
                  <div className="success-msg success-login success-new-msg">
                    <p className="success-msg success-login" >{uploadSuccess}</p>
                  </div>
                  : null
              }
              {
                uploadErr ?
                  <div className="error-msg error-login" >
                    <p className="error-msg error-login">{uploadErr}</p>
                  </div>
                  : null
              }
            </div>







          </Typography>
        </DialogContent>
      </BootstrapDialog>

      {/* modal section end */}


    </>
  )
}
export default Applicationstatus;